import { POLL_CONFIG, SOCKETIO_RECONNECT_INTERVAL } from '../constants';
import { emitAnnouncementEvent } from '../util/Helpers';
import { getAccessToken } from './core/auth/utils';

const URL = process.env.REACT_APP_MERCURY_URL;

const { io } = require('socket.io-client');

let roomId = '';
let joined = false;
let socket;
let tokenInterval = null;

const registerdFunction = {
  new_staff_message: null,
  relationship: null,
};

function whenSocketReady(callback) {
  if (socket?.connected) {
    callback();
    return;
  }

  if (socket) {
    socket.once('connect', callback);
    return;
  }

  let attempts = 0;
  const maxAttempts = 600;
  const waiter = setInterval(() => {
    attempts += 1;
    if (socket) {
      clearInterval(waiter);
      if (socket.connected) {
        callback();
      } else {
        socket.once('connect', callback);
      }
    } else if (attempts >= maxAttempts) {
      clearInterval(waiter);
    }
  }, 50);
}

function attachSocketListeners(activeSocket) {
  activeSocket.on('connect', function () {
    joinRoom(activeSocket.id);
  });

  activeSocket.on('disconnect', function () {
    joined = false;
  });

  activeSocket.on('connect_error', () => {
    setTimeout(() => {
      activeSocket.connect();
    }, SOCKETIO_RECONNECT_INTERVAL);
  });

  activeSocket.on('message', function (data) {
    if (registerdFunction[data.action]) {
      registerdFunction[data.action](data.payload || data.data);
    } else if (registerdFunction[`${data.action}_for_unread_count`]) {
      registerdFunction[`${data.action}_for_unread_count`](data.payload);
    }
  });

  activeSocket.on('announcement', function (data) {
    emitAnnouncementEvent(data);
  });

  activeSocket.on('voice_keyword_detected', function (data) {
    try {
      if (registerdFunction[data.action]) {
        registerdFunction[data.action](data.payload);
      }
    } catch (error) {
      console.error('Error handling voice_keyword_detected event:', error);
    }
  });
}

export function establishSocketConnection() {
  if (socket?.connected) {
    return;
  }

  if (tokenInterval) {
    return;
  }

  const tryConnect = async () => {
    try {
      const token = await getAccessToken();
      if (!token) {
        return;
      }

      if (tokenInterval) {
        clearInterval(tokenInterval);
        tokenInterval = null;
      }

      if (socket) {
        socket.removeAllListeners();
        socket.disconnect();
      }

      socket = io(URL, {
        extraHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      attachSocketListeners(socket);
    } catch (error) {
      console.error('Socket connection attempt failed:', error);
    }
  };

  tokenInterval = setInterval(tryConnect, 5000);
  void tryConnect();
}

export function registerAction(callback) {
  registerdFunction[callback.event] = callback.action;
}

export function removeAction(event) {
  registerdFunction[event] = false;
}

export function joinRoom(id) {
  if (!POLL_CONFIG.USE_POLLING) {
    roomId = id;
    if (joined) {
      return;
    }
    if (socket) {
      socket.emit('message', {
        action: 'join_room',
        room_id: roomId,
      });
      joined = true;
    }
  }
}

export function joinMeetingRoom(meetingId) {
  if (!meetingId) {
    return;
  }

  const emitMeetingJoin = () => {
    if (!socket?.connected) {
      return;
    }
    socket.emit('message', {
      action: 'join_room',
      room_id: meetingId,
    });
  };

  if (!socket?.connected) {
    if (!socket) {
      establishSocketConnection();
    }
    whenSocketReady(emitMeetingJoin);
    return;
  }

  emitMeetingJoin();
}